import Crypto from 'crypto-browserify';
import React from 'react';

import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Delete from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import Heading from '../../../../shared/components/heading';


const md5 = (appName) => {

  return Crypto.createHash('md5').update(appName, 'utf-8').digest('hex');
};

const styles = theme => ({
  view: {
    marginTop: '40px'
  },
  text: {
    fontSize: '14px'
  },
  textApproved: {
    fontSize: '12px'
  }
});

class ApprovedApplications extends React.Component {

  constructor(props) {

    super(props);
    this.generateInit = this.generateInit.bind(this);
  }

  generateInit(applicationName, clientId) {

    return async function() {

      return this.props.onRevokeClick(applicationName, clientId);
    }.bind(this);
  }

  render() {

    return (
      <Grid container spacing={0} className={this.props.classes.view}>
        <Grid item xs={12}>
          <Heading text='Manage Application Access'/>
          <Typography color="textSecondary" className={this.props.classes.text}>These applications have been permitted access to your account information. You can remove an account's access by clicking the {<Delete style={{position: 'relative', top: '4px', width: '16px', height: '16px'}} />} button next to its name.</Typography>
        </Grid>
        <Grid item xs={12}>
          <div>
            <List>
              {
                this.props.grants.length ?
                this.props.grants.map((i) => {

                const asDate = new Date(i.since);
                const asPrintableDate = `${asDate.getMonth() + 1}-${asDate.getDate()}-${asDate.getFullYear()}`;

                return (
                  <ListItem key={i.id}>
                    <ListItemAvatar>
                    {
                      i.appIconUrl ?
                      (<Avatar alt={i.name} src={i.appIconUrl} />) :
                      (<Avatar alt={i.name} src={`https://www.gravatar.com/avatar/${md5(i.name)}?d=identicon&f=y`} />)
                    }
                    </ListItemAvatar>
                    <ListItemText primary={
                        <div>
                        <div><strong>{i.name}</strong></div>
                        <div className={this.props.classes.textApproved}><em>Approved on {asPrintableDate}</em></div>
                        </div>
                    } />
                    <ListItemIcon>
                      <Delete style={{ cursor: 'pointer', width: '16px', height: '16px' }} onClick={this.generateInit(i.name, i.clientId)} />
                    </ListItemIcon>
                    </ListItem>
                  )
                })
                :
                <ListItem key="none-000">
                  <ListItemText primary="No approved applications." />
                </ListItem>
              }
            </List>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ApprovedApplications);
